module.exports = __webpack_public_path__ + "img/goal-four-br.0728f1a5.png";